// function isSliderInitialized(){
//     let result;
//     this.slider = document.querySelector('#tee-gallery');
//     if(this.slider){
//         result = true;
//     }else{
//         result = false;
//     }

//     return result;
// }

function addInfoBlocks(){
    let slider = document.querySelector('#tee-gallery');
    if(slider){
        // Live-Vorschau Text hinzufügen
        const dommove = document.querySelector(".tee-gallery");
        if (dommove && !document.getElementById("product-preview")) {
            const previewDiv = document.createElement("div");
            previewDiv.id = "product-preview";
            previewDiv.textContent = "Live-Vorschau deines Produkts";
            previewDiv.style.color = "#393939";
            previewDiv.style.textAlign = "center";
            previewDiv.style.fontSize = "12px";
            previewDiv.style.marginBottom = "4px";
            dommove.insertBefore(previewDiv, dommove.firstChild);
        }
    }
}

function addScrollAnimation(){
    const image = document.querySelector('.tee-gallery-content');

    window.addEventListener('scroll', (event) => {
        if(window.innerWidth <= 750){
            const scrollY = window.scrollY;
            let maxScroll = 100;
            const minWidth = 58;

            if (scrollY <= maxScroll) {
                // const newWidth = 100 - (scrollY / maxScroll) * (100 - minWidth);
                const t = scrollY / maxScroll;          // 0 → 1
                const eased = Math.sqrt(t);             // easing
                const newWidth = 100 - eased * (100 - minWidth);
                image.style.width = newWidth + '%';
            } else {
                image.style.width = minWidth + '%';
            }
            window.dispatchEvent(new Event('resize'));
        }
    });
}

function handleStickyGallery() {
    const wrapper = document.querySelector('.teeinblue-enabled .grid__item.product__media-wrapper');
    if (!wrapper) return;

    function checkSticky() {
        const rect = wrapper.getBoundingClientRect();
        if (rect.top <= 0) {
            document.body.classList.add('tee-gallery-sticky');
        } else {
            document.body.classList.remove('tee-gallery-sticky');
        }
    }

    window.addEventListener('scroll', checkSticky);
    window.addEventListener('resize', checkSticky);
    checkSticky();
}

function fixedLivePreview(){
    const style = document.createElement("style");
    style.innerHTML = `
        @media only screen and (max-width: 768px) {
            .teeinblue-enabled .grid__item.product__media-wrapper {
                width: calc(100% + 30px);
                max-width: 100vw;
                position: relative;
                position: sticky;
                top: 0;
                z-index: 3;
                transition: all .3s ease-in-out;
                margin-left: -15px;
                background: #FFFFFF;
                padding-bottom: 10px;
            }

            .teeinblue-enabled.tee-gallery-sticky .grid__item.product__media-wrapper {
            background: #FFFFFF;
            box-shadow: 0 2px 5px 3px rgba(0, 0, 0, .15);
        }
        
        .teeinblue-enabled .grid__item.product__media-wrapper #tee-gallery {
            height: auto !important;
            margin: 0 auto;
            max-width: calc(100% - 30px);
            }
        }
    `;
    document.head.appendChild(style);

    // let slider = document.querySelector('#tee-gallery');
    // let interval = setInterval(()=>{
        // let isSlider = isSliderInitialized();
        // if(isSlider){
            // clearInterval(interval);
            addInfoBlocks();
            addScrollAnimation();
            handleStickyGallery();
        // }
    // },500)
}

document.addEventListener("DOMContentLoaded", () => {
    const w = window.innerWidth;
    const h = window.innerHeight;
    if (h / w > 1.5 && w < 768) {
        const observer = new MutationObserver((mutations, obs) => {
            const target = document.querySelector('#tee-gallery');
            if (target) {
                fixedLivePreview();
                obs.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
});